import api from './api';

export const getNCRs = (params = {}) => api.get('/ncr/', { params });

export const getNCR = (id) => api.get(`/ncr/${id}`);

export const createNCR = (data) => api.post('/ncr/', data);

export const updateNCR = (id, data) => api.put(`/ncr/${id}`, data);

export const closeNCR = (id, data) => api.put(`/ncr/${id}/close`, data);
